<template>
  <div class="quote-wrap">
    <div
      class="quote ucase m-auto"
      v-html="content"></div>
  </div>
</template>

<script>
export default {
  name: 'Quote',
  props: {
    content: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.quote-wrap {
  display: flex;
  width: 100%;

  .quote {
    max-width: rem(1190);
    text-align: center;

    @include mobile {
      text-align: left;
    }
  }
}
</style>
